import { useEffect, useMemo, useState } from 'react';
import { AppleFilled, WindowsFilled } from '@ant-design/icons';
import { SiderbarHeader } from './components/header/index.js';
import { Icon } from '@docs/kd-d2c-components';
import {
  eed_mario_icon_clock_line,
  eed_mario_icon_study_line,
} from '@/assets/icons';
import { openFeedbackGroup } from '@/pages/pc/kim';
import { SidebarMenu } from './components/menu/index.js';
import { Kim01NavQunzunLineIcon } from '@kim/ui';
import intl from '@/internationalzation/intl';
import { EventBus } from '@/utils/event-bus';
import { GlobalEventType } from '@src/types';
import { openDownloadUrl } from '@/pages/pc/kim';
import './index.less';
import { isInClaw } from '@src/utils/is-in-claw';
import { getClawVersionDownloadUrls } from '@src/services/claw/api';
import {
  getCurrentDownloadPlatform,
  getDownloadUrlForCurrentPlatform,
  type DownloadPlatform,
} from '@src/utils/download-platform';
import { useLocation } from 'react-router-dom';
import { isMainagentPath } from '@src/utils/mainagent-route';

interface ISidebarProps {
  onFoldClick: () => void;
}
export const Sidebar = (props: ISidebarProps) => {
  const { onFoldClick } = props;
  const location = useLocation();
  const isInClawFlag = isInClaw();
  const [downloadUrl, setDownloadUrl] = useState('');
  const [downloadTarget, setDownloadTarget] =
    useState<DownloadPlatform>('intel');

  const isClawMode = useMemo(() => {
    const p = location.pathname;
    return (
      isMainagentPath(p) ||
      p === '/skills' ||
      p.startsWith('/skills/')
    );
  }, [location.pathname]);

  useEffect(() => {
    if (isInClawFlag) {
      return;
    }

    getClawVersionDownloadUrls()
      .then((data) => {
        const target = getCurrentDownloadPlatform();
        setDownloadTarget(target);
        // 仅使用当前平台的链接，无链接则不展示（避免 Windows/Intel 显示错误或点下载拿到 dmg）
        setDownloadUrl(getDownloadUrlForCurrentPlatform(data, target));
      })
      .catch(() => {
        setDownloadUrl('');
      });
  }, [isInClawFlag]);

  const downloadLabelMap: Record<'win' | 'arm' | 'intel', string> = {
    win: 'Download for Windows',
    arm: 'Download for Mac',
    intel: 'Download for Mac',
  };

  const [showTask, setShowTask] = useState(false);

  return (
    <div className="kim-ai-mario-sidebar">
      {/* 新建任务 */}
      <SiderbarHeader onFoldClick={onFoldClick} onTaskChange={setShowTask} />
      {<SidebarMenu />}

      <footer className="kim-ai-mario-sidebar-footer">
        {!isInClawFlag && downloadUrl && (
          <div className="kim-ai-mario-sidebar-footer-download">
            <div
              className="kim-ai-mario-sidebar-footer-download-btn"
              onClick={() => openDownloadUrl(downloadUrl)}
            >
              {downloadTarget === 'win' ? <WindowsFilled /> : <AppleFilled />}
              <span>{downloadLabelMap[downloadTarget]}</span>
            </div>
          </div>
        )}
        <div className="kim-ai-mario-sidebar-footer-btns">
          {!isInClawFlag && (
            <div
              className="kim-ai-mario-sidebar-footer-btn"
              onClick={() => {
                openFeedbackGroup();
              }}
            >
              <Kim01NavQunzunLineIcon size={16} />
              <div className="kim-ai-mario-sidebar-bottom-text">
                {intl.t('反馈群')}
              </div>
            </div>
          )}
          {isInClawFlag && (
            <a
              href="kim://thread?id=6707037163754771&type=4"
              target="_blank"
              className="kim-ai-mario-sidebar-footer-btn"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <Kim01NavQunzunLineIcon size={16} />
              <div className="kim-ai-mario-sidebar-bottom-text">
                {intl.t('反馈群')}
              </div>
            </a>
          )}
          <div
            className="kim-ai-mario-sidebar-footer-btn"
            onClick={() => {
              if (isClawMode) {
                window.openExternalLink(
                  'https://docs.corp.kuaishou.com/k/home/Vfs9ohCpOIL8',
                );
                return;
              }
              EventBus.emit(GlobalEventType.SCHEDULER_VIEW_ALL_TASK);
            }}
          >
            {isClawMode ? (
              <Icon icon={eed_mario_icon_study_line} size={16} />
            ) : (
              <Icon icon={eed_mario_icon_clock_line} size={16} />
            )}
            <div className="kim-ai-mario-sidebar-bottom-text">
              {isClawMode ? intl.t('帮助中心') : intl.t('定时任务')}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};
